<div class="blockquote-wrapper" [ngClass]="block.data.style === 'style2' ? 'blockquote-wrapper--style2' : 'blockquote-wrapper--style1'">
    <blockquote class="blockquote" *ngIf=block.data.blockquote>
        <span class="blockquote__image" *ngIf="block.data.image" [ngStyle]="{backgroundImage: block.data.image ? 'url(' + block.data.image_url + ')' : null}"></span>

        <p class="blockquote__text" [innerHTML]="block.data.blockquote"></p>

        <footer class="blockquote__footer" *ngIf=block.data.cite>
            <cite class="blockquote__cite">
                <a class="blockquote__cite-link" [href]=block.data.citeLink *ngIf=block.data.citeLink [innerHTML]="block.data.cite"></a>
                <span class="blockquote__cite-text" *ngIf=!block.data.citeLink [innerHTML]="block.data.cite"></span>
            </cite>
        </footer>
    </blockquote>
</div>
